import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { DialogBuilder } from "~/utils/DialogProvider";
import useStyles, { Container } from "./styles";
import { Grid, Typography, Button } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { CheckboxColor } from "~/views/VendorServiceScheduling/styles";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import Utils from "~/helpers/Utils";
import { useTranslation } from "react-i18next";
import checkoutServices from "~/services/checkoutServices";
import VendorCheckoutPackage from "../VendorCheckoutPackage";
import bookingTransactionService from "~/services/bookingTransactionService";
import { useParams, withRouter } from "react-router-dom/cjs/react-router-dom.min";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import { ModalBottom } from "~/components/common/modalBottom/modalBottom";
import Footer from "~/components/common/footerContainer/FooterContainer";
import ScheduleDiv from "~/components/common/scheduleDiv/ScheduleDiv";
import ButtonsLogin from "~/components/common/buttonsLogin";
import BusinessHeader from "~/components/common/businessHeader";
import businessService from "~/services/businessService";
import DialogPix from "~/components/common/dialog/dialogPix";
import DialogAddCard from "~/components/common/dialog/dialogAddCard";
import DialogPayConfirmPackage from "~/components/common/dialog/dialogPayConfirmPackage";
import dialogPayCod from "~/components/common/dialog/dialogPayCod";
import packagesServices from "~/services/packagesServices";
import WhatsAppLoginButton from "~/components/common/whatsappLogin";

const VendorPackages = (props) => {
	const {id} = useParams();
	const { t, i18n } = useTranslation();
	const classes = useStyles();

	const { business: businessStore } = useSelector((store) => store.business);
	const { user } = useSelector((store) => store.auth);
	const { me: meStore } = useSelector((store) => store.me);
	const dialog = useContext(DialogBuilder);

	const business = Utils.safeParseJSON("@prit-web/business", businessStore);
	const showLoginGoogle = !business ? false : business?.gmailClient;
	const currency = business?.currency;
	const me = Utils.safeParseJSON("@prit-web/meData", meStore);

	const [loading, setLoading] = useState(false);
	const [whatsAppLoading, setWhatsAppLoading] = useState(false);

	const [checkoutInformation, setCheckoutInformation] = useState(null);
	const [loadingCheckoutInformation, setLoadingCheckoutInformation] = useState(false);
	const [animationTrigger, setAnimationTrigger] = useState(0);

	const [errorMessage, setErrorMessage] = useState("");
	const [showError, setShowError] = useState(false);

	const [packages, setPackages] = useState([]);
	const [selectedPackage, setSelectedPackage] = useState(null);

	const [validationPritPay, setValidationPritPay] = useState(false);
	const [handlePackageBuy, setHandlePackageBuy] = useState(false);
	const [showVendorDescription, setShowVendorDescription] = useState(false);

	const [contract, setContract] = useState();
	const [pix, setPix] = useState();
	const [pixCode, setPixCode] = useState();
	const [showUpdateInfo, setShowUpdateInfo] = useState(false);
	const [cardData, setCardData] = useState();

	const saveSelectedPackage = (packageData) => {
		if (packageData) {
			localStorage.setItem("@prit-web/selectedPackage", JSON.stringify(packageData));
		} else {
			localStorage.removeItem("@prit-web/selectedPackage");
		}
	};

	const restoreSelectedPackage = () => {
		try {
			const savedPackage = localStorage.getItem("@prit-web/selectedPackage");
			if (savedPackage) {
				const parsedPackage = JSON.parse(savedPackage);
				setSelectedPackage(parsedPackage);
				return parsedPackage;
			}
		} catch (error) {
			console.error("Erro ao restaurar pacote selecionado:", error);
			localStorage.removeItem("@prit-web/selectedPackage");
		}
		return null;
	};

	const handleCheckboxChange = (packageItem) => {
		setSelectedPackage((prevSelected) => {
			const isAlreadySelected = prevSelected?.body?.package_id === packageItem.id;

			let updatedSelectedPackages;
			if (isAlreadySelected) {
				updatedSelectedPackages = [];
			} else {
				updatedSelectedPackages = [packageItem];
			}

			const newSelectedPackage = generateBookingPayload(updatedSelectedPackages);
			
			saveSelectedPackage(newSelectedPackage);
			
			return newSelectedPackage;
		});
	};

	const generateBookingPayload = (selectedPackagesList) => {
		if (selectedPackagesList.length === 0) {
			setSelectedPackage(null);
			return null;
		}

		let allBookings = [];
		let infoPackage = null;
		let selectedPackageId = null;

		if (selectedPackagesList.length === 1) {
			selectedPackageId = selectedPackagesList[0].id;
		}

		for (const packageItem of selectedPackagesList) {
			const bookings = [];
			const info = {
				serviceName: packageItem.service?.name,
				duration: packageItem.service?.duration,
				packageName: packageItem.name,
				pricingType: packageItem.pricingType,
				quantity: packageItem.quantity,
				packagePrice: packageItem.price,
				validity: packageItem.bookingExpirationDays,
			};
			infoPackage = info;
			for (let i = 0; i < packageItem.quantity; i++) {
				const data = {
					business_id: packageItem.business?.id,
					professional_id: packageItem.professional?.id,
					service_id: packageItem.service?.id,
					pricing_type_id: packageItem.pricingType?.id,
					acesso: "web",
					answer: "",
					price: packageItem.price / packageItem.quantity,
				};

				bookings.push(data);
			}
			allBookings = [...allBookings, ...bookings];
		}

		const payload = {
			body: {
				bookings: allBookings,
				is_cancellation_policy: false,
				is_offer_refused: false,
				package_id: selectedPackageId,
			},
			info: infoPackage,
		};

		setSelectedPackage(payload);
		return payload;
	};

	const fetchCheckoutInformation = async (packageData) => {
		if (!packageData?.body?.bookings?.length || !business?.id) return;

		setLoadingCheckoutInformation(true);
		try {
			const bookingPrice = packageData.body.bookings.reduce((total, booking) => total + booking.price, 0);

			const { data } = await checkoutServices.fetchCancellationPolicyScreen(business.id, business?.language);

			const format = {
				total_value_for_services: bookingPrice,
				total_discounts: 0,
				anticipation_payment: bookingPrice,
				amount: bookingPrice,
				cancellation_policy: data?.cancellation_policy ?? null,
			};

			setCheckoutInformation(format);
			businessService.getContract(business.id).then(({ data }) => {
				setContract(data);
				setLoading(false);
			});
		} catch (error) {
			console.error("Erro ao buscar informações de checkout:", error);
			setLoading(false);
		} finally {
			setLoadingCheckoutInformation(false);
		}
	};

	const validateAdvancedBilling = (checkoutInfo) => {
		if (!checkoutInfo?.cancellation_policy) return false;

		return !!(
			checkoutInfo.cancellation_policy.fixed_cancellation ||
			checkoutInfo.cancellation_policy.percentage_cancellation ||
			checkoutInfo.cancellation_policy.anticipated_payment
		);
	};

	const roundPricesDown = (body, bookingTotalPrice) => {
		const bookings = body?.bookings;

		if (!bookings || !Array.isArray(bookings)) {
			return body;
		}

		const roundedBookings = bookings.map((item) => {
			const price = Number(item.price) || 0;
			return {
				...item,
				price: Math.floor(price),
			};
		});

		const sumRoundedPrices = roundedBookings.reduce((total, booking) => total + booking.price, 0);
		const difference = bookingTotalPrice - sumRoundedPrices;

		if (difference > 0) {
			roundedBookings[0] = {
				...roundedBookings[0],
				price: roundedBookings[0].price + difference,
			};
		}

		return {
			...body,
			bookings: roundedBookings,
		};
	};

	const postBooking = async () => {
		setLoading(true);
		try {
			if (!selectedPackage) {
				setErrorMessage("Pacote de informações inválido.");
				setShowError(true);
				return;
			}
			const bodyWithRoundedPrices = roundPricesDown(selectedPackage.body, selectedPackage.info?.packagePrice);
			if (user && !user.isAnonymous && me?.name && validateAdvancedBilling(checkoutInformation)) {
				return await bookingTransactionService.postBookingTransaction({...bodyWithRoundedPrices, is_cancellation_policy: validateAdvancedBilling(checkoutInformation)});
			} else {
				await bookingTransactionService.postBookingTransaction(bodyWithRoundedPrices);
				props.history.push(`/confirmation-package/${business?.id}`, {
					checkout: checkoutInformation,
					business: business,
					infoPackage: selectedPackage,
					isPackage: true
				});
			}
		} catch (error) {
			setErrorMessage(error?.message || "Verifique sua conexão e tente novamente");
			setShowError(true);
		} finally {
			setLoading(false);
		}
	};

	const goToNextPage = () => {
		props.history.push(`/checkout-package/${business?.id}`, {
			...selectedPackage,
		});
	};

	const handleAddSchedulingPackage = async () => {
		saveSelectedPackage();
		try {
			if (!validationPritPay) {
				setAnimationTrigger(prev => prev + 1);
				setHandlePackageBuy(true);
				return;
			}

			if (handlePackageBuy) {
				await postBooking();
			} else {
				setHandlePackageBuy(true);
			}
		} catch (error) {
			console.error("Erro ao adicionar agendamento:", error);
		}
	};

	const loadPackages = async () => {
		try {
			await packagesServices.packagesList(id, business?.language).then((res) => {
				setPackages(res.data);
			});
		} catch (error) {
			dialog.withTitle("Erro").withMessage(error.message).show();
		}
	};

	const handleGoBack = () => {
		if (handlePackageBuy) {
			setHandlePackageBuy(false);
			setAnimationTrigger(prev => prev + 1);
		} else {
			props.history.goBack();
		}
	};

	const shouldShowBackButton = () => {
		return true;
	};

	const footer = () => {
		return <Footer section="agendar" bussinesId={business?.id} setLoading={(value) => setLoading(value)} />;
	};

	const goToBusinessProfile = () => {
		return props.history.push(`/perfil-business/${business?.id}`);
	}

	useEffect(() => {
		if (checkoutInformation) return;
		if (
			selectedPackage?.body?.bookings?.length &&
			!loadingCheckoutInformation &&
			(me || me?.name || (me?.phone && me?.phoneUnverified) || user || user?.isAnonymous)
		) {
			fetchCheckoutInformation(selectedPackage);
		}
	}, [selectedPackage, business?.id]);

	useEffect(() => {
		if (packages.length > 0 && !selectedPackage) {
			restoreSelectedPackage();
		}
	}, [packages]);

	useEffect(() => {
		if (loadingCheckoutInformation) {
			setLoading(false);
		}
	}, [loadingCheckoutInformation]);

	useEffect(() => {
		if (validateAdvancedBilling(checkoutInformation)) {
			setValidationPritPay(false);
		} else {
			setValidationPritPay(true);
		}
	}, [checkoutInformation]);

	useEffect(() => {
		if (props?.location?.state?.packages) {
			setPackages(props.location.state.packages)
		} else {
			loadPackages();
		}

	}, [business?.id]);

	useEffect(() => {
		if (cardData || pix) {
			dialog
				.withContent(DialogPayConfirmPackage)
				.withProps({
					cardData,
					pix,
					checkoutInformation,
					currency,
					payload: selectedPackage,
					postBooking,
					setPixCode,
					selectedPackage,
					business,
					showUpdateInfo: () => setShowUpdateInfo(!showUpdateInfo),
					showError: (msg) => {
						setErrorMessage(msg);
						setShowError(true);
					},
				})
				.show();
		}
	}, [cardData, pix]);

	useEffect(() => {
		if (showUpdateInfo) {
			if (pix) {
				dialog.withContent(DialogPix).withProps({ setPix }).show();
			} else {
				dialog
					.withContent(DialogAddCard)
					.withProps({
						setCardData,
					})
					.show();
			}
			setShowUpdateInfo(false);
		}
	}, [showUpdateInfo]);

	useEffect(() => {
		if (showError) {
			dialog.withMessage(errorMessage).show();
		}
	}, [showError]);

	useEffect(() => {
		if (pixCode) {
			dialog
				.withContent(dialogPayCod)
				.withProps({
					pixCode,
					businessId: business.id,
				})
				.show();
		}
	}, [pixCode]);

	return (
		<>
			<TitleContainer
				headerStyle={{ boxShadow: "0", padding: "0" }}
				footer={!selectedPackage ? footer() : null}
				imageVisible={true}
				backgroundNew={true}
				showFooter={true}
				showGradient={true}
				loading={loading || loadingCheckoutInformation}>
				<BusinessHeader
					business={business}
					onSeeMoreClick={goToBusinessProfile}
				/>
				<Grid container direction="column" style={{ Maxheight: "100vh", minHeight: "30vh", background: "transparent" }}>
					<ModalBottom
						activeButton={selectedPackage}
						title={t("Service packages")}
						showVendorDescription={showVendorDescription}
						setShowVendorDescription={setShowVendorDescription}
						containerButtonStyle={{
							position: "fixed",
							bottom: me?.name ? 55 : 50,
							backgroundColor: "#FDFCF8",
							maxWidth: "480px",
							left: 0,
							right: 0,
							margin: "0 auto",
						}}
						animate={animationTrigger}
						showBackButton={shouldShowBackButton()}
						onBackClick={handleGoBack}
						buttonCustom={() => {
							if (showVendorDescription) {
								return null;
							}
							return (
								<>
									{!me || !me?.name || (!me?.phone && !me?.phoneUnverified) || !user || user?.isAnonymous ? (
										<WhatsAppLoginButton
											successRoute={`/packages/${business?.id}`}
											label={t("verify with whatsapp")}
											business={business}
											onLoadingChange={setWhatsAppLoading}
											language={i18n?.language || "pt-BR"}
											showCustomLogin={true}
											goBackRouteProps={props.location.state}
											showLoginGoogle={showLoginGoogle}
											style={{
												textTransform: "uppercase",
												fontWeight: "Bold",
												marginBottom: "5%",
												border: "none",
												height: 44,
												fontSize: "clamp(14px, 1vw, 18px)",
												backgroundColor: "#672E37",
												color: "#fff",
												opacity: whatsAppLoading ? 0.5 : 1
											}}
										/>
									) : (
										<>
											{!handlePackageBuy ? (
												<div
													style={{
														width: "100%",
														display: "flex",
														justifyContent: "center",
														backgroundColor: "transparent",
														padding: "0px",
														display: "flex",
														alignItems: "center",
														justifyContent: "center",
													}}>
													<ScheduleDiv handleClick={handleAddSchedulingPackage} business={false} label={t("Active")} />
												</div>
											) : (
												<>
													{validationPritPay ? (
														<div
															style={{
																width: "100%",
																display: "flex",
																justifyContent: "center",
																backgroundColor: "transparent",
																padding: "0px",
																display: "flex",
																alignItems: "center",
																justifyContent: "center",
															}}>
												<ScheduleDiv handleClick={handleAddSchedulingPackage} business={false} label={t("Confirm activation")} />
														</div>
													) : (
														<div style={{ justifyContent: "space-evenly", width: "100%", display: "flex", padding: 16 }}>
															{!_.isNull(contract?.transaction_percentage) && (
																<Button
																	onClick={() => {
																		if (user && !user.isAnonymous) {
																			setPix(null);
																			setCardData(null);
																			dialog
																				.withContent(DialogAddCard)
																				.withProps({
																					setCardData,
																				})
																				.show();
																		}
																	}}
																	style={{
																		width: contract?.pix_transaction_percentage !== null ? "45%" : "100%",
																		float: "left",
																		marginRight: "1px",
																	}}
																	className={classes.root}>
																	{t("Pay with card")}
																</Button>
															)}
															{!_.isNull(contract?.pix_transaction_percentage) && (
																<Button
																	onClick={() => {
																		if (user && !user.isAnonymous) {
																			setPix(null);
																			setCardData(null);
																			dialog.withContent(DialogPix).withProps({ setPix }).show();
																		}
																	}}
																	style={{
																		width: contract?.transaction_percentage !== null ? "45%" : "100%",
																		marginRight: "1px",
																	}}
																	className={classes.root}>
																	{t("Pay with pix")}
																</Button>
															)}
														</div>
													)}
												</>
											)}
										</>
									)}
								</>
							);
						}}>
						<Container style={{ background: "transparent", padding: 0 }}>
							{!handlePackageBuy ? (
								<>
									{packages.length > 0 ? (
										<>
											{packages.map((item, idx) => (
												<div
													key={item.id}
													className={classes.levelTileDiv}
													style={{ cursor: "pointer", marginBottom: 10 }}
													onClick={() => handleCheckboxChange(item)}>
													<div
														className={classes.levelTileAlign}
														style={{
															display: "flex",
															alignItems: "center",
															border: "1px solid rgba(0, 0, 0, 0.2)",
															padding: "4px",
															borderRadius: "8px",
														}}>
														<CheckboxColor
															checked={selectedPackage?.body?.package_id === item.id}
															checkedIcon={<CheckCircleIcon style={{ fontSize: 20, color: "#672E37" }} />}
															icon={<RadioButtonUncheckedIcon style={{ fontSize: 20, color: "rgba(0,0,0,0.2)" }} />}
															style={{ marginBottom: 2 }}
														/>
														<div
															style={{
																display: "flex",
																alignItems: "center",
																justifyContent: "space-between",
																width: "100%",
															}}>
															<div>
																<h4 className={classes.nameList} style={{ margin: 0 }} translate="no">
																	{item.name}
																</h4>
																<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
																	<Typography className={classes.description} translate="no">{item?.service?.name}</Typography>
																</div>
																<div style={{ display: "flex", alignItems: "center", gap: 8 }}>
																	<Typography className={classes.description}>
																		{t("packageSessionDetails", {
																			quantity: item.quantity,
																			session: item.quantity > 1 ? t("sessions") : t("session"),
																			duration: Utils.formatMinutes(item.service?.duration),
																			each: t("each")
																		})}
																	</Typography>
																</div>
															</div>
															<div>
																<h4 className={classes.price} style={{ margin: 0, paddingRight: 10 }}>
																	{Utils.getServicePricingType(item, business, t)}
																</h4>
															</div>
														</div>
													</div>
												</div>
											))}
										</>
									) : (
										<div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", color: "rgba(0,0,0,0.6" }}>
											<Typography>{t("No packages found")}</Typography>
										</div>
									)}
								</>
							) : (
								<>
									<VendorCheckoutPackage selectedPackage={selectedPackage} business={business} />
								</>
							)}
						</Container>
					</ModalBottom>
				</Grid>
			</TitleContainer>
		</>
	);
};

export default withRouter(VendorPackages);
